import { UserDb } from 'lib/cosmos/user/userDb.js';
import { map } from 'rxjs';
import { MainBrandingFormComponent } from '../../modules/branding/main-branding-form.component.js';
import {
	ICoreRoutes,
	IPageMetadata,
	ISharedData,
	ITypeRoute,
	ITypeRouteAction,
	RouteInitializer
} from '../../pages/type-routes/type-route.models.js';

export interface IBrandingRouteData {
	user: UserDb.IUserItem;
}

export interface IBrandingRoutes extends ICoreRoutes {
	form: ITypeRoute<
		IBrandingRouteData,
		{
			main: ITypeRouteAction<IBrandingRouteData>;
		}
	>;
}

export const brandingRoutes: RouteInitializer<IBrandingRoutes> = {
	form: {
		mainPath: 'branding',
		uniqueId: 'brandingOverview',
		parentRoutes: (context) => [],
		loadSharedData: (context) => {
			return context.dependencies.httpService
				.get<UserDb.IUserItem>((builder) =>
					builder.withCustomApiRoute('user', 'getUser').withId(context.authUser.id).build()
				)
				.pipe(
					map((response) => {
						const shared: ISharedData<IBrandingRouteData> = {
							data: {
								user: response.data
							},
							linkedItems: response.linkedItems
						};
						return shared;
					})
				);
		},
		menuItems: (context) => [],
		children: {
			main: {
				uniqueId: `brandingMain`,
				component: MainBrandingFormComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `Branding`
					};

					return metadata;
				}
			}
		}
	}
};
